import type { SVGProps } from 'react';
const DawnFlagCN = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-CN_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-CN_svg__a)">
      <path fill="#F1361D" d="M0 0h22v16H0z" />
      <path
        fill="#FFDC42"
        fillRule="evenodd"
        d="m7.914 2.48.761.133.57.529.13-.775.52-.581-.76-.132-.571-.53-.13.776zm2.038 2.71.66-.408.771.018-.401-.671.018-.786-.66.408-.771-.018.401.672zm-.894 4.387-.645.431-.01-.785-.423-.657.771-.01.645-.431.01.786.424.656zm.56-2.032.767-.086.692.348-.085-.781.342-.705-.767.087-.692-.348.085.78zM5.239 6.581 3.39 7.922l.682-2.203L2.25 4.344l2.268-.02.72-2.19.721 2.19 2.269.02L6.404 5.72l.682 2.203z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagCN;
